module.exports = __webpack_public_path__ + "img/dynamic3.394b5cbf.png";